// ML CRO 2026-05-27: replace static "PROMOTION" badge with computed "-X%" discount
(function(){
  function parsePrice(text){
    if(!text) return 0;
    var n = text.replace(/[^\d,\.]/g, '').replace(',', '.');
    return parseFloat(n);
  }
  function inject(){
    var cards = document.querySelectorAll('product-card, .product-card');
    cards.forEach(function(card){
      var priceEl = card.querySelector('span.price');
      var compareEl = card.querySelector('s.compare-at-price, .compare-at-price');
      if(!priceEl || !compareEl) return;
      var cur = parsePrice(priceEl.textContent);
      var orig = parsePrice(compareEl.textContent);
      if(!cur || !orig || cur >= orig) return;
      var pct = Math.round((1 - cur/orig) * 100);
      if(pct < 1) return;
      // find Promotion badge (rectangle, not custom)
      var badges = card.querySelectorAll('.product-badges__badge--rectangle');
      badges.forEach(function(badge){
        if(badge.classList.contains('product-badges__badge--custom')) return;
        if(badge.dataset.mlPctInjected) return;
        badge.textContent = '−' + pct + '%';
        badge.dataset.mlPctInjected = '1';
      });
    });
  }
  function init(){
    inject();
    // Re-run on dynamic DOM swaps (Shopify sections/filters)
    var rerun;
    var mo = new MutationObserver(function(){
      clearTimeout(rerun);
      rerun = setTimeout(inject, 80);
    });
    mo.observe(document.body, {childList:true, subtree:true});
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
